import { HostListener, Component, OnInit, Output, AfterContentChecked, ViewChild, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute } from '@angular/router';

import { ErrorObject } from '../../app/errorhandler/gpiserror-object';
import { ErrorHandlerService } from '../../app/errorhandler/gpiserror-handler.service';
import { IReturnObject } from '../shared/return-object.model';
import { ErrorTypeEnum, StatusEnum, SupplierValidForEnum } from '../shared/enums.model';
import { ComponentCanDeactivate } from '../../app/shared/page.pendingchangesguard';
import { SupplierContactService } from './supplier-contacts.service';
import { UserHandling } from '../shared/user-handling';
import { ConfirmResult } from '../../app/dialogboxes/shared/confirm.model'
import { InputTimerAction } from '../shared/input-timer-action';
import { SupplierService } from '../../app/supplier/supplier.service';
import { SupplierListBE, SupplierBE } from '../../app/supplier/shared/supplier.model';
import { SupplierContactBE } from './shared/supplier-contact.model';
import { SetFocus } from '../../app/shared/setFocus';
import { User } from '../shared/user.model';
import { DashboardComponent } from '../../app/dashboard/dashboard.component';
import { empty } from 'rxjs/observable/empty';
import { ChineseChangeValueService } from '../chinese-change-value.service';

@Component({
    moduleId: module.id,
    selector: 'supplier-contact',
    templateUrl: 'supplier-contact.html',
    providers: [SupplierContactService, SupplierService],
})
export class SupplierContactComponent implements OnInit, AfterContentChecked, ComponentCanDeactivate {
    showSpinner: boolean = false;
    viewSupplierListSpinner: boolean = false;

    supplierList: SupplierListBE[];
    extendedSupplierList: SupplierListBE[];
    suppliercontactlist: SupplierListBE[];
    supplierContacts: SupplierContactBE[];
    extendedSupplierContacts: SupplierContactBE[];
    selectedSupplierName: string = "";
    extendedsupplierNames: string = "";
    selectedSupplierId: number = 0;
    extendedSupplierIds: string = "";
    isSelectedSupplierInfoExpired: boolean = false;
    isSupplierExistsInMainStoreOrWashingSupplier: boolean = false;
    selectionNo: number = 2;
    extendedSupplierNamesList: any;

    // supplier search
    searchSupplierText: string = "";
    viewSupplierList: boolean = false;
    searchKeyStrokeDelay: number = 350;
    typeDelayTimer: any = null;
    supplierSearchListDelayTimer: any = null;
    searchListDelayTimerDelay: number = 250;

    // confirm dialog
    @ViewChild('cDlg') cdlg: ElementRef;
    dialogAction: string;
    dialogBtnType: string;
    dialogAppliesTo: string = "";
    dialogAppliesToId: number = -1;
    confirmDlgText: string = "";
    currentDlg: NgbModalRef;

    // misc
    user: UserHandling = new UserHandling();
    isDirty: boolean = false;
    errorObj: ErrorObject = null;
    setFocus: SetFocus = new SetFocus();
    isFocusSet: boolean = false;
    isContactsInfoExpired: boolean = false;

    constructor(
        private supplierContactService: SupplierContactService,
        private modalService: NgbModal,
        private supplierService: SupplierService,
        private errHandler: ErrorHandlerService,
        private route: ActivatedRoute,
        private ChineseChangeValueService:ChineseChangeValueService
    ) {
        errHandler.errorEvent.subscribe((err: ErrorObject) => this.onError(err));
    }

    ngOnInit() {
        if ((this.user.IsPartSupplierUser || this.user.IsPackagingEngineer || this.user.IsPackagingAdmin)) {
            if (this.user.SupplierNumber != null) {
                if (this.user.SupplierNumber !== 'undefined') {
                    this.getSupplierBySupplierNo(this.user.SupplierNumber, this.user.ExtendedSupplierNumber);
                }
            }
            if(this.user.IsPackagingAdmin || this.user.IsPackagingEngineer)
            this.isSupplierExistsInMainStoreOrWashingSupplier = true;


        }
    }

    ngAfterContentChecked() {
        this.isFocusSet = this.setFocus.to("searchSupplier", this.isFocusSet);
    }

    @HostListener('window:beforeunload')
    canDeactivate(): Observable<boolean> | boolean {
        return !this.isDirty;
    }

    // ----------------------------------------------------------
    // Fetch list data
    // ----------------------------------------------------------

    loadSupplierList() {
        this.viewSupplierListSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.supplierService.searchSupplier(this.searchSupplierText)
            .subscribe(returnObject => this.loadSupplierListResponse(returnObject));
    }

    loadSupplierListResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.loadSupplierListResponse', returnObject.ErrorType);
        else
            this.supplierList = returnObject.DataList;

        this.viewSupplierListSpinner = false;
    }

    // ----------------------------------------------------------
    // Actions
    // ----------------------------------------------------------
    delete(contactId: number) {
        this.openConfirmDeleteDlg(contactId);
    }

    doDelete(contactId: number) {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        if (contactId < 0) {
            this.supplierContacts.splice(this.supplierContacts.findIndex(x => x.Id == contactId), 1);
            this.showSpinner = false;
        }
        else {
            this.supplierContactService.deleteContact(contactId)
                .subscribe(returnObject => this.deleteResponse(returnObject, contactId));
        }
    }

    deleteResponse(returnObject: IReturnObject, contactId: number) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.deleteResponse', returnObject.ErrorType);
        } else {
            this.supplierContacts.splice(this.supplierContacts.findIndex(x => x.Id == contactId), 1);
            this.showSpinner = false;
        }
    }

    selectSupplier(supplier: SupplierListBE) {
        this.supplierContacts = [];
        this.selectedSupplierId = supplier.Id;
        this.selectedSupplierName = supplier.Supplier;
        clearInterval(this.supplierSearchListDelayTimer);
        this.getSupplierContacts(supplier.Id);
    }

    addNewContanct() {
        if (this.supplierContacts == undefined)
            this.supplierContacts = [];
        let obj: SupplierContactBE = new SupplierContactBE();
        obj.Id = -1;
        obj.SupplierId = this.selectedSupplierId;
        this.supplierContacts.push(obj);
        this.setDirty();
    }

    update(contactItem: SupplierContactBE) {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        let isValidText: string = "";
        if (contactItem.Name.trim() == "") {
            isValidText = isValidText + "- Contact name must not be empty.\n";
        }
        if (contactItem.Email.trim() == "") {
            isValidText = isValidText + "- Email must not be empty.\n";
        }
        if (contactItem.Phone != "" && this.isPhoneNumberInvalid(contactItem.Phone)) {
            isValidText = isValidText + "- Your phone number can contain numbers and these special characters: ( ) . - + # * /\n  Space is not allowed.";
        }
        if (contactItem.IsSparePart == -1) {
            isValidText = isValidText + "- 'Valid for' field is mandotory.\n";
        }
        if (isValidText.length > 0) {
            alert(isValidText);
            this.showSpinner = false;
            return;
        }
        this.supplierContactService.updateContact(contactItem)
            .subscribe(returnObject => this.updateResponse(returnObject, contactItem.Id));
    }

    updateResponse(returnObject: IReturnObject, contactIdBeforeSave: number) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.updateResponse', returnObject.ErrorType);

        } else {
            let updatedItem = returnObject.DataList[0];
            this.supplierContacts.splice(this.supplierContacts.findIndex(x => x.Id == contactIdBeforeSave)
                , 1
                , updatedItem);
            this.isDirty = false;
            if (contactIdBeforeSave == returnObject.DataList[0].Id)
                this.info("Contact updated: " + updatedItem.Name);
            else
                this.info("Contact added: " + updatedItem.Name);
        }
        this.showSpinner = false;
    }

    getSupplierBySupplierNo(supplierNo: string, extendedSupplierNo: string) {
        if (supplierNo != null) {
            if (supplierNo !== 'undefined') {
                if (supplierNo != "0") {
                    this.showSpinner = true;
                    clearInterval(this.typeDelayTimer);
                    this.errHandler.emitErrorObject(null);
                    this.supplierService.getSupplierBySupplierNo(supplierNo, extendedSupplierNo)
                        .subscribe(returnObject => this.getSupplierBySupplierNoResponse(returnObject));
                }
            }
        }
    }

    getSupplierBySupplierNoResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.getSupplierBySupplierNoResponse', returnObject.ErrorType);
        else {
          if(returnObject.DataList.length > 0){
            this.selectedSupplierName = returnObject.DataList[0].Supplier;
            this.selectedSupplierId = returnObject.DataList[0].Id;
          }

            this.suppliercontactlist = returnObject.DataList.filter(item => item.Id != returnObject.DataList[0].Id);
            if (this.suppliercontactlist != null){
              this.extendedsupplierNames = Array.prototype.map.call(this.suppliercontactlist, s => s.Supplier).join(", ");
              this.extendedSupplierIds = Array.prototype.map.call(this.suppliercontactlist, s => s.Id).join(",");
              this.extendedSupplierNamesList = this.extendedsupplierNames.split(',');
            }

            if(returnObject.DataList.length > 0){
              if (returnObject.DataList[0].ContactInfoConfirmationDate != null) {
                this.isSelectedSupplierInfoExpired = this.supplierService.isSupplierInfoValid(returnObject.DataList[0].ContactInfoConfirmationDate)
              }
            }

            else
                this.isSelectedSupplierInfoExpired = true;
            this.getSupplierContacts(this.selectedSupplierId);

            if(this.extendedSupplierIds.length > 0)
            {
              this.getExtendedSupplierContacts(this.extendedSupplierIds);
            }

            this.showSpinner = false;
        }
        this.viewSupplierListSpinner = false;
    }

    getSupplierContacts(supplierId: number) {
        this.showSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.supplierContactService.getContacts(supplierId)
            .subscribe(returnObject => this.getSupplierContactsResponse(returnObject));
    }

    getExtendedSupplierContacts(extendedSupplierIds: string) {
        this.showSpinner = true;
        clearInterval(this.typeDelayTimer);
        this.errHandler.emitErrorObject(null);
        this.supplierContactService.getExtendedContacts(extendedSupplierIds)
            .subscribe(returnObject => this.getExtendedSupplierContactsResponse(returnObject));
    }

    getSupplierContactsResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError)
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.getSupplierContactResponse', returnObject.ErrorType);
        if (returnObject.DataList.length > 0) {
            this.supplierContacts = returnObject.DataList;
            if(this.user.IsPartSupplierUser)
            this.checkForSupplierInMainStoreOrWashingSupplier();
            this.showSpinner = false;
        }
        else {
            this.showSpinner = false;
        }
        this.isFocusSet = false;
        this.isFocusSet = this.setFocus.to("contactName", this.isFocusSet);
    }

    getExtendedSupplierContactsResponse(returnObject: IReturnObject) {
      if (returnObject.ErrorType != ErrorTypeEnum.NoError)
          this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.getExtendedSupplierContactResponse', returnObject.ErrorType);
      if (returnObject.DataList.length > 0) {
          this.extendedSupplierContacts = returnObject.DataList;
          console.log(this.extendedSupplierContacts,"extendedSupplierContacts")
          if(this.user.IsPartSupplierUser)
          this.checkForSupplierInMainStoreOrWashingSupplier();
          this.showSpinner = false;
      }
      else {
          this.showSpinner = false;
      }
      this.isFocusSet = false;
      this.isFocusSet = this.setFocus.to("contactName", this.isFocusSet);
  }

    info(message: string): void {
        this.errHandler.emitError(message, '', ErrorTypeEnum.Info);
    }

    markContactInfoUpdated() {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);
        this.supplierContactService.markContactInfoUpdated(this.selectedSupplierId)
            .subscribe(returnObject => this.markContactInfoUpdatedResponse(returnObject));
    }

    markContactInfoUpdatedResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.markContactInfoUpdatedResponse', returnObject.ErrorType);
        } else {
            this.isSelectedSupplierInfoExpired = false;
            this.info("Contact information is succesfully confirmed.")
        }
        this.showSpinner = false;
    }


    // ----------------------------------------------------------
    // Dialog boxes
    // ----------------------------------------------------------
    openConfirmDeleteDlg(contactId: number) {
        this.errHandler.emitErrorObject(null);
        this.dialogAction = "delete";
        this.dialogBtnType = "danger";
        this.dialogAppliesTo = "Supplier contact";
        this.dialogAppliesToId = contactId;
        this.currentDlg = this.modalService.open(this.cdlg, { size: 'sm' });
    }
    onConfirmDlgNotify(command: ConfirmResult): void {
        this.closeDlg();
        if (command.Action == "delete") {
            this.doDelete(command.Id);
        }
        else {
            this.closeDlg();
        }
    }
    closeDlg() {
        this.currentDlg.close();
    }

    // ----------------------------------------------------------
    // GUI control
    // ----------------------------------------------------------


    // ----------------------------------------------------------
    // Search suppliers
    // ----------------------------------------------------------
    searchSuppTextChanged() {
        var that = this; // needed to preserve scope reference to this within setinterval function

        if (that.searchSupplierText.length >= 2) {
            that.viewSupplierList = true;

            // If this.typeDelayTimer is not nulll then the
            // user typed somthing new within time limit so reset timer
            if (that.typeDelayTimer != null)
                clearInterval(that.typeDelayTimer);

            that.typeDelayTimer = setInterval(function () {
                that.loadSupplierList();
            }, that.searchKeyStrokeDelay);
        }
        else {
            that.viewSupplierList = false;
            clearInterval(this.typeDelayTimer);
        }
    }

    startSupplierSearchListWithDelay() {
        var that = this;

        if (!that.viewSupplierList) {
            clearInterval(this.supplierSearchListDelayTimer);
            return;
        }

        if (that.supplierSearchListDelayTimer != null)
            clearInterval(that.supplierSearchListDelayTimer);

        that.supplierSearchListDelayTimer = setInterval(function () {
            that.finalizeHideSupplierSearchListWithDelay();
        }, that.searchListDelayTimerDelay);
    }

    finalizeHideSupplierSearchListWithDelay() {
        this.viewSupplierList = false;
        clearInterval(this.supplierSearchListDelayTimer);
    }

    hideSupplierSearchListWithDelay() {
        clearInterval(this.supplierSearchListDelayTimer);
        this.startSupplierSearchListWithDelay();
    }

    showSupplierSearchList() {
        if (this.searchSupplierText.length >= 2) {
            clearInterval(this.supplierSearchListDelayTimer);
            this.viewSupplierList = true;
        }
    }

    // ----------------------------------------------------------
    // MISC
    // ----------------------------------------------------------
    setDirty() {
        this.isDirty = true;
    }

    onError(error: ErrorObject) {
        this.errorObj = this.errHandler.getError();
    }

    isUpdateDisabled(contactItem: SupplierContactBE): boolean {

        if (contactItem.dirty == undefined)
            return true;
        else if (!contactItem.dirty)
            return true
        this.setDirty();
        return false;
    }

    isDeleteDisabled() {
        if (this.user.IsPartSupplierUser || this.user.IsPackagingEngineer || this.user.IsPackagingAdmin || this.user.IsDeveloper)
            return false;
        else
            return true;
    }

    isPhoneNumberInvalid(telNo: string) {
        let regexp = new RegExp('[^0-9+-/*()#]');
        let res = regexp.test(telNo);
        return res;
    }

    // ------------------------------------------------------
    //Access rights control
    // ------------------------------------------------------
    isPageAccessible(): boolean {
        return (this.user.IsPackagingAdmin
            || this.user.IsPackagingEngineer
            || this.user.IsDeveloper
            || this.user.IsPartSupplierUser);
    }

    isAddingDisabled(): boolean {
        if (this.user.IsPartSupplierUser || this.user.IsPackagingEngineer || this.user.IsPackagingAdmin || this.user.IsDeveloper)
            return (((this.supplierContacts != undefined) || (this.supplierContacts != null))
                ? this.supplierContacts.some(x => x.Id == -1) : false)
        else
            return true;

    }


    checkForSupplierInMainStoreOrWashingSupplier() {
        this.showSpinner = true;
        this.errHandler.emitErrorObject(null);

        this.supplierContactService.CheckForSupplierInMainStoreOrWashingSupplier(this.selectedSupplierId)
            .subscribe(returnObject => this.checkForSupplierInMainStoreOrWashingSupplierResponse(returnObject));
    }

    checkForSupplierInMainStoreOrWashingSupplierResponse(returnObject: IReturnObject) {
        if (returnObject.ErrorType != ErrorTypeEnum.NoError) {
            //this.errHandler.emitError(returnObject.ErrorMsg, 'SupplierContactComponent.checkForSupplierInMainStoreOrWashingSupplierResponse', returnObject.ErrorType);
        } else {
            if(this.user.IsPartSupplierUser){
                if(returnObject.DataList[0])
                  this.isSupplierExistsInMainStoreOrWashingSupplier = true;
            }
        }
        this.showSpinner = false;
    }
}





// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/supplier-contact/supplier-contact.component.ts